import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { browserHistory } from 'react-router';

import { message, Modal, Skeleton } from 'antd';

import PackageForm from './PackageForm';

import { createPackage, updatePackage, getPackage, deletePackage } from '../store/actions';
import { getTranslatedString } from 'helpers/i18n';

import { Published, Archived } from './Form/constants';
import ActionButtons from './Form/ActionButtons';

const StyledContainer = styled.div`
  padding: 0 24px;
`;

const modes = {
  CREATE: 'create',
  EDIT: 'edit',
  LOADING: 'loading',
};

const CREATE_FORM = 'create_package_form';
const EDIT_FORM = 'edit_package_form';

const CreateOrUpdatePackage = ({ routeParams }) => {
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState(modes.LOADING);

  const [currentPackage, setCurrentPackage] = useState({});

  const toApplicationTemplates = () => browserHistory.push('/companies/application_templates');

  useEffect(() => {
    if (routeParams.applicationPackageId) {
      getPackage(routeParams.applicationPackageId).done((response) => {
        setCurrentPackage(response.application_package);
        setMode(modes.EDIT);
      });
    } else {
      setCurrentPackage({});
      setMode(modes.CREATE);
    }
  }, [routeParams]);

  const handleCreate = async (values) => {
    try {
      setLoading(true);
      await createPackage(values);

      Modal.success({
        title: getTranslatedString('landlordPortal.applicationPackages.package.successCreateTitle'),
        content: getTranslatedString(
          'landlordPortal.applicationPackages.package.successCreateContent'
        ),
        onOk: toApplicationTemplates,
      });
    } catch (error) {
      setLoading(false);
      message.error(getTranslatedString('unknownError'));
    }
  };

  const handleUpdate = async (values, packageId) => {
    try {
      setLoading(true);
      await updatePackage(packageId, values);

      Modal.success({
        title: getTranslatedString('landlordPortal.applicationPackages.package.successSavedTitle'),
        content: getTranslatedString(
          'landlordPortal.applicationPackages.package.successSavedContent'
        ),
        onOk: toApplicationTemplates,
      });
    } catch (error) {
      setLoading(false);
      message.error(getTranslatedString('unknownError'));
    }
  };

  const handlePublish = async (values, packageId) => {
    try {
      await updatePackage(packageId, { ...values, status: Published });

      Modal.success({
        title: getTranslatedString(
          'landlordPortal.applicationPackages.package.successPublishedTitle'
        ),
        content: getTranslatedString(
          'landlordPortal.applicationPackages.package.successPublishedContent'
        ),
        onOk: toApplicationTemplates,
      });
    } catch (error) {
      setLoading(false);
      message.error(getTranslatedString('unknownError'));
    }
  };

  const handleDeletePackage = async (values, packageId) => {
    try {
      await deletePackage(packageId);

      Modal.success({
        title: getTranslatedString(
          'landlordPortal.applicationPackages.package.successDeletedTitle'
        ),
        content: getTranslatedString(
          'landlordPortal.applicationPackages.package.successDeletedContent'
        ),
        onOk: toApplicationTemplates,
      });
    } catch (error) {
      setLoading(false);
      message.error(getTranslatedString('unknownError'));
    }
  };

  const handleArchivePackage = async (values, packageId) => {
    try {
      await updatePackage(packageId, { ...values, status: Archived });

      Modal.success({
        title: getTranslatedString(
          'landlordPortal.applicationPackages.package.successArchivedTitle'
        ),
        content: getTranslatedString(
          'landlordPortal.applicationPackages.package.successArchivedContent'
        ),

        onOk: toApplicationTemplates,
      });
    } catch (error) {
      setLoading(false);
      message.error(getTranslatedString('unknownError'));
    }
  };

  const renderMode = () => {
    if (mode === modes.CREATE) {
      return (
        <PackageForm
          formTitle={getTranslatedString(
            'landlordPortal.applicationPackages.package.createPackage'
          )}
          formName={CREATE_FORM}
          formData={currentPackage}
          onClickBackButton={toApplicationTemplates}
          actionButtons={
            <ActionButtons
              status={currentPackage.status}
              loading={loading}
              onCreate={handleCreate}
              onUpdate={handleUpdate}
              onArchive={handleArchivePackage}
              onPublish={handlePublish}
              onDelete={handleDeletePackage}
            />
          }
        />
      );
    }
    if (mode === modes.EDIT) {
      return (
        <PackageForm
          formTitle={getTranslatedString('landlordPortal.applicationPackages.package.editPackage')}
          formName={EDIT_FORM}
          formData={currentPackage}
          onClickBackButton={toApplicationTemplates}
          actionButtons={
            <ActionButtons
              status={currentPackage.status}
              loading={loading}
              onCreate={handleCreate}
              onUpdate={handleUpdate}
              onArchive={handleArchivePackage}
              onPublish={handlePublish}
              onDelete={handleDeletePackage}
            />
          }
        />
      );
    }
    if (mode == modes.LOADING) {
      return (
        <StyledContainer>
          <Skeleton
            paragraph={{
              rows: 1,
            }}
          />
        </StyledContainer>
      );
    }
  };

  return (
    <div className="body" role="main">
      {renderMode()}
    </div>
  );
};

export default CreateOrUpdatePackage;
